<template>
    <!-- 部门列表 -->
    <vDepartmentList :postList="postList" v-if="flag"></vDepartmentList>
</template>
<script>
import vDepartmentList from '../../listComponent/jurisdiction/departmentListComponent.vue';
export default {
    name: 'departmentList',
    components: {
        vDepartmentList
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                code: true,
                name: true,
                parent_rid: true,
                rank: true,
                principal_hierarchy_rid: true,
                status: true,
                addBtn: true,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>